// hooks/useOnboarding.ts
import { useEffect, useState } from 'react';

export function useOnboarding() {
  const [isFirstTime, setIsFirstTime] = useState<boolean>(false);
  const [isOnboardingVisible, setIsOnboardingVisible] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    checkFirstTime();
  }, []);

  const checkFirstTime = () => {
    try {
      const hasSeenOnboarding = localStorage.getItem('vet:hasSeenOnboarding');
      const firstTime = !hasSeenOnboarding;
      
      setIsFirstTime(firstTime);
      setIsOnboardingVisible(firstTime);
      setIsLoading(false);
    } catch (error) {
      console.error('Erro ao verificar primeiro acesso:', error);
      setIsLoading(false);
    }
  };

  const completeOnboarding = () => {
    try {
      localStorage.setItem('vet:hasSeenOnboarding', 'true');
      setIsFirstTime(false);
      setIsOnboardingVisible(false);
    } catch (error) {
      console.error('Erro ao salvar estado do onboarding:', error);
    }
  };

  const skipOnboarding = () => {
    completeOnboarding();
  };

  const resetOnboarding = () => {
    try {
      localStorage.removeItem('vet:hasSeenOnboarding');
      setIsFirstTime(true);
      setIsOnboardingVisible(true);
    } catch (error) {
      console.error('Erro ao resetar onboarding:', error);
    }
  };

  return {
    isFirstTime,
    isOnboardingVisible,
    isLoading,
    completeOnboarding,
    skipOnboarding,
    resetOnboarding,
    setIsOnboardingVisible
  };
}